module.exports = __webpack_public_path__ + "img/Microphone - Green - Selected.e3af008e.png";